import * as types from '../constants/actionTypes';

export const fetchProductPriceHistoryRequest = (productId, params = {}) => ({
  type: types.FETCH_PRODUCT_PRICE_HISTORY_REQUEST,
  payload: { productId, params },
});
export const fetchProductPriceHistorySuccess = (productId, data) => ({
  type: types.FETCH_PRODUCT_PRICE_HISTORY_SUCCESS,
  payload: { productId, data },
});
export const fetchProductPriceHistoryFailure = (error) => ({
  type: types.FETCH_PRODUCT_PRICE_HISTORY_FAILURE,
  payload: error,
});

export const fetchVendorPriceHistoryRequest = (vendorId, params = {}) => ({
  type: types.FETCH_VENDOR_PRICE_HISTORY_REQUEST,
  payload: { vendorId, params },
});
export const fetchVendorPriceHistorySuccess = (vendorId, data) => ({
  type: types.FETCH_VENDOR_PRICE_HISTORY_SUCCESS,
  payload: { vendorId, data },
});
export const fetchVendorPriceHistoryFailure = (error) => ({
  type: types.FETCH_VENDOR_PRICE_HISTORY_FAILURE,
  payload: error,
});

export const fetchPriceInflationRequest = (params = {}) => ({
  type: types.FETCH_PRICE_INFLATION_REQUEST,
  payload: params,
});
export const fetchPriceInflationSuccess = (data) => ({
  type: types.FETCH_PRICE_INFLATION_SUCCESS,
  payload: data,
});
export const fetchPriceInflationFailure = (error) => ({
  type: types.FETCH_PRICE_INFLATION_FAILURE,
  payload: error,
});
